// Spotify app integration ID
export const CLIENT_ID = 'adbbfb7cb3ab453197b1a75c6dc19629';
export const APP_SCOPE = 'user-library-read app-remote-control streaming user-modify-playback-state user-read-playback-state user-read-currently-playing';

// #region URLs
export const SPOTIFY_PLAYER_URL = "https://open.spotify.com/"
export const SPOTIFY_ACCOUNT_API_BASE_URL = "https://accounts.spotify.com";
export const SPOTIFY_WEP_API_BASE_URL = "https://api.spotify.com/v1";

// TEST - RedirectUri
//export const REDIRECT_URI = 'http://localhost:3000';
// PROD - RedirectUri
export const REDIRECT_URI = "https://albumania.halvaren.dev"

// #endregion URLs